import React, {createContext, useContext} from 'react'
import PropTypes from 'prop-types'

const HeaderNavLayoutContext = createContext({isTwoRow: false})

export const useHeaderNavLayout = () => useContext(HeaderNavLayoutContext)

export function HeaderNavLayoutProvider({value, children}) {
    return (
        <HeaderNavLayoutContext.Provider value={value}>{children}</HeaderNavLayoutContext.Provider>
    )
}

HeaderNavLayoutProvider.propTypes = {
    value: PropTypes.shape({isTwoRow: PropTypes.bool}).isRequired,
    children: PropTypes.node.isRequired
}
